/**
 * Handle cases when developers pass object instead of instance of an Error
 * also errors like "Non-Error exception captured with keys: $id, detail, message, type"
 */
export function handleNonErrorException(exception) {
    switch (true) {
        case 'message' in exception && exception?.message: {
            return Object.assign(new Error(exception.message), exception);
        }
        case 'error' in exception && exception?.error?.message: {
            return Object.assign(new Error(exception.error.message), exception?.error);
        }
        case 'exception' in exception && exception?.exception?.message: {
            return Object.assign(new Error(exception.exception.message), exception?.exception);
        }
        default: {
            // only if we failed to overcome problem we warn about incorrect argument
            console.log('ErrorMonitor: please pass instance of an Error, instead error monitor received', exception);
            return exception;
        }
    }
}
//# sourceMappingURL=handleNonErrorException.js.map